import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Observable, forkJoin } from 'rxjs';
import { QCFlowDetails, QCFlowFile, QCFlowDetailsResponse } from '../models/qc-flow-details';
import { QCFlowBulkAction, QCFlowRecord, MatchedRuleRecords} from '../models/qc-flow-records';
import { AutoTesterDetails, AutoTesterTestCaseDto } from '../models/auto-tester';

@Injectable({
  providedIn: 'root'
})
export class AutoTesterService {

  baseUrl = environment.apiEndpoint + '/autotester/';

  constructor(private http: HttpClient) { }

  GetDetails(projectId: string): Observable<AutoTesterDetails> {
    return this.http.get<AutoTesterDetails>(this.baseUrl + projectId + '/details');
  }

  GetTestCase(projectId: string, testCaseId: string): Observable<AutoTesterTestCaseDto> {
    return this.http.get<AutoTesterTestCaseDto>(this.baseUrl + projectId + '/testcase/' + testCaseId);
  }

  GetTestCases(projectId: string): Observable<AutoTesterTestCaseDto[]> {
    return this.http.get<AutoTesterTestCaseDto[]>(this.baseUrl + projectId + '/testcase');
  }

  CreateDetails(projectId: string): Observable<any> {
    return this.http.post(this.baseUrl + projectId + '/details', {});
  }

  SaveTestCase(projectId: string, testCase: AutoTesterTestCaseDto): Observable<AutoTesterTestCaseDto> {
    return this.http.post<AutoTesterTestCaseDto>(this.baseUrl + projectId + '/testcase', testCase);
  }

  DeleteTestCase(projectId: string, testCaseId: string): Observable<any> {
    return this.http.delete(this.baseUrl + projectId + '/testcase/' + testCaseId);
  }
  
  RunTestCase(projectId: string, testCaseId: string): Observable<any> {
    return this.http.put(this.baseUrl + projectId + '/testcase/' + testCaseId + '/run', {});
  }
  GetTestRespondentVideo(projectId: string, testCaseId: string, respondentId: string) {
    return this.http.get<any>(this.baseUrl + projectId + '/testcase/' + testCaseId + '/' + respondentId + '/video');
  }

  GetTestQuestionImage(projectId: string, questionLabel: string) {
    return this.http.get<any>(this.baseUrl + projectId + '/question/' + questionLabel + '/image');
  }
}

